import { Link } from "react-router-dom";
import { cn as classJoin } from "../../lib/utils";

const TONE = {
    slate: "text-slate-900",
    emerald: "text-emerald-700",
    rose: "text-rose-700",
    amber: "text-amber-700",
    indigo: "text-indigo-700",
};

export default function KpiTile({ label, value, hint, icon, tone = "slate", testid, hrefRoute }) {
    const Inner = (
        <div className="reedos-card p-4 hover:border-slate-900 transition-colors h-full" data-testid={testid}>
            <div className="reedos-eyebrow flex items-center gap-1.5 text-[9px]">{icon} {label}</div>
            <div className={classJoin("font-display font-bold reedos-data text-2xl mt-1 leading-none", TONE[tone])}>{value}</div>
            {hint && <div className="text-[11px] text-slate-500 mt-1.5">{hint}</div>}
        </div>
    );
    return hrefRoute ? <Link to={hrefRoute} className="block h-full">{Inner}</Link> : Inner;
}
